import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonRightText from 'components/atoms/Button/Button.rightText';
import { isACtiveSatisfyModal, disableAllMenu, isActiveConversationGuideModal, isActiveServiceGuideModal } from 'modules/actions/statusMenu';
import { chatList } from 'modules/actions/chat';
import PropTypes from 'prop-types';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';

const SideMenu = ({ styleDef }) => {
  const sendBtnStatus = useSelector(state => state.isActive.sendBtn);
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);
  const chatListLength = useSelector(state => state.chatList.data.length);

  const divRef = useRef(null);

  const dispatch = useDispatch();

  const execOnSendMsg = text => {
    const paramSet = {
      inType: 'query',
      inStr: text,
      inLabel: text,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };

  const onSatisfyModal = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isACtiveSatisfyModal());
  };
  const onConversationGuide = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isActiveConversationGuideModal());
  };
  const onMenualGuide = () => {
    window.open(`${process.env.PUBLIC_URL}/manual.pdf`);
  };
  
  /*
  const keyboardNavigation = useCallback(
   (e) => {
      if (e.key === 'ArrowDown') {
        setCursor((prev) => (prev < data.data.length -1 ? prev + 1 : prev ));
      }
      if (e.key === 'ArrowUp') {
        setCursor((prev) => (prev > 0 ? prev -1 : ));
      }
    },
    [data, setCursor, cursor],
  )
  */
 
  /* 웹접근성: 설정 메뉴 클릭 시 tabindex */
  const quickBtnElement = document.querySelector('.menu-trigger');
  const setBtnElement = document.querySelector('.set');
  const restartBtnElement = document.querySelector('.restart');
  const headerCloseBtnElement = document.querySelector('._header_close');
  
  if (sideMenuStatus) {
    setBtnElement.setAttribute('tabindex', '-1');
    restartBtnElement.setAttribute('tabindex', '-1');
    headerCloseBtnElement.setAttribute('tabindex', '-1');
  } else {
    const setBtnElementTabIndex = document.querySelector('.set[tabindex]');
    if (setBtnElementTabIndex) {
      setBtnElement.removeAttribute('tabindex');
      restartBtnElement.removeAttribute('tabindex');;
      headerCloseBtnElement.removeAttribute('tabindex');
    }
  }
  
  /* SideMenu 닫기 */
  const offSideMenu = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    document.querySelector('.menu-trigger').focus();
  };

  return (
    <ul className="menu_bar" style={styleDef}>
      <ButtonRightText
        label="대화 가이드"
        value="대화 가이드"
        labelIcon="chatGuide"
        viewStatus=""
        styleDef={{}}
        divRef={divRef}
        onClickEvt={() => execOnSendMsg('챗봇 대화 가이드')}
        error={null}
      />
      <ButtonRightText
        label="서비스 만족도 평가"
        value="서비스 만족도 평가"
        labelIcon="serviceSatisfaction"
        viewStatus=""
        styleDef={{}}
        onClickEvt={() => onSatisfyModal()}
        error={null}
      />
      <ButtonRightText
        label="이용 매뉴얼 다운로드"
        value="이용 매뉴얼 다운로드"
        labelIcon="manualDownload"
        viewStatus=""
        styleDef={{}}
        onClickEvt={() => onMenualGuide()}
        error={null}
      />
      <div className='_btn_right_txt_div' style={{display: 'block', textAlign:'center', borderBottom:'1px solid #ededed', fontWeight:'600', padding:'', paddingTop:'10px'}} onClick={() => dispatch(disableAllMenu())}>
        <button type='button' className='leftSetClose' onClick={() => offSideMenu()}>
          <span clasName='_btnText'>닫기</span>
          <i className='ri-close-line'style={{fontSize: '20px', position:'relative', top:'5px', color:'rgb(64,96,157)',fontWeight:'600'}}/>
        </button>
      </div>
    </ul>
  );
};

SideMenu.propTypes = {
  styleDef: PropTypes.object,
};
SideMenu.defaultProps = {
  styleDef: {},
};
export default SideMenu;
